module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [(_vm.showShop) ? _c('span', [_vm._v("\n        分店："), _c('el-select', {
    staticClass: "w150 mr20",
    attrs: {
      "clearable": "",
      "placeholder": "请选择分店"
    },
    model: {
      value: (_vm.queryParams.shopNum),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "shopNum", $$v)
      },
      expression: "queryParams.shopNum"
    }
  }, _vm._l((this.shopList), function(item) {
    return _c('el-option', {
      key: item.shopNum,
      attrs: {
        "label": item.name,
        "value": item.shopNum
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v("\n      角色："), _c('el-select', {
    staticClass: "w150 mr20",
    attrs: {
      "clearable": "",
      "placeholder": "请选择角色"
    },
    model: {
      value: (_vm.queryParams.roleType),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "roleType", $$v)
      },
      expression: "queryParams.roleType"
    }
  }, _vm._l((this.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v("\n      姓名："), _c('el-input', {
    staticClass: "w150",
    attrs: {
      "placeholder": "请输入姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "name", $$v)
      },
      expression: "queryParams.name"
    }
  }), _vm._v("\n    手机号："), _c('el-input', {
    staticClass: "w150",
    attrs: {
      "placeholder": "请输入手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "mobile", $$v)
      },
      expression: "queryParams.mobile"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "ml20",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.queryList()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": this.changeType == 1 ? '配置角色' : '设置',
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [(this.changeType == 2) ? _c('el-row', [_c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "头像",
      "required": "",
      "prop": ""
    }
  }, [_c('el-upload', {
    ref: "upload",
    class: {
      uploaderNone: _vm.hideUpload
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange,
      "on-remove": _vm.handleRemove,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v("\n            *提示*：为了更好的用户体验，图片请提供160*160像素，文件大小不超过500kb。\n          ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '08:00',
        step: '00:30',
        end: '22:00'
      }
    },
    model: {
      value: (_vm.formparams.begintime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "begintime", $$v)
      },
      expression: "formparams.begintime"
    }
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '08:00',
        step: '00:30',
        end: '22:00',
        minTime: _vm.formparams.begintime
      }
    },
    model: {
      value: (_vm.formparams.endtime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "endtime", $$v)
      },
      expression: "formparams.endtime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "每节课时长",
      "prop": "classtime"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入单节课时长（分钟）"
    },
    model: {
      value: (_vm.formparams.classtime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "classtime", _vm._n($$v))
      },
      expression: "formparams.classtime"
    }
  }), _vm._v("分\n          ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教练简介",
      "prop": "info"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入教练信息"
    },
    model: {
      value: (_vm.formparams.info),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "info", $$v)
      },
      expression: "formparams.info"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.changeType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "修改密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.formparams.password),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "password", $$v)
      },
      expression: "formparams.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.changeType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "roleid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.roleid),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "roleid", $$v)
      },
      expression: "formparams.roleid"
    }
  }, _vm._l((this.roles), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.remark,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.changeType != 3) ? _c('el-form-item', {
    attrs: {
      "label": "上线状态"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "上线",
      "inactive-text": "下线"
    },
    model: {
      value: (_vm.formparams.isWeb),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "isWeb", $$v)
      },
      expression: "formparams.isWeb"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (this.changeType == 2) ? _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitFormTeach('formparams')
      }
    }
  }, [_vm._v("确 定")]) : _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "73vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属分店",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm._f("caseType")(scope.row.shopNum)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "phone",
      "label": "联系电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "员工角色"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.role) ? _c('div', [_vm._v(" " + _vm._s(scope.row.role) + " ")]) : _c('div', [_vm._v(" 未配置 ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "角色类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.roletype == 0) ? _c('div', [_vm._v(" 教练 ")]) : _vm._e(), _vm._v(" "), (scope.row.roletype == 1) ? _c('div', [_vm._v(" 会籍 ")]) : _vm._e(), _vm._v(" "), (scope.row.roletype == 2) ? _c('div', [_vm._v(" 店长 ")]) : _vm._e(), _vm._v(" "), (scope.row.roletype == 3) ? _c('div', [_vm._v(" 董事长 ")]) : _vm._e(), _vm._v(" "), (scope.row.roletype == 4) ? _c('div', [_vm._v(" 会籍主管 ")]) : _vm._e(), _vm._v(" "), (scope.row.roletype == 5) ? _c('div', [_vm._v(" 教练主管 ")]) : _vm._e(), _vm._v(" "), (scope.row.roletype == null) ? _c('div', [_vm._v(" 未设置 ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "教练信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.roletype == 0 || scope.row.roletype == 5) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top",
            "width": "300px"
          }
        }, [_c('div', {
          staticClass: "menuTree"
        }, [_c('div', [_vm._v("上课时间： " + _vm._s(scope.row.begintime) + " - " + _vm._s(scope.row.endtime) + " ")]), _vm._v(" "), _c('div', [_vm._v("每节课时长（分）： " + _vm._s(scope.row.classtime))])]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-tag', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("鼠标放上查看详情")])], 1)]) : _c('div', [_vm._v("非教练")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inday",
      "label": "注册时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "上线状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isWeb == 1) ? _c('div', [_vm._v("上线")]) : _vm._e(), _vm._v(" "), (scope.row.isWeb == 0) ? _c('div', [_vm._v("下线")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-row', [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.editRole(scope.row)
            }
          }
        }, [_vm._v("配置角色")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.editPassword(scope.row)
            }
          }
        }, [_vm._v("修改密码")])], 1), _vm._v(" "), _c('el-row', {
          staticStyle: {
            "marginTop": "20px"
          }
        }, [(scope.row.roletype == 0 || scope.row.roletype == 5) ? _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (scope.row.roletype == 0 || scope.row.roletype == 5) ? _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.restInfo(scope.row)
            }
          }
        }, [_vm._v("休息设置")]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageination"
  }, [_c('el-col', [_c('el-pagination', {
    staticStyle: {
      "textAlign": "center",
      "marginTop": "10px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 40, 80, 100],
      "page-size": 20,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2e3603ac"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/configurable/teacherInfo.vue
// module id = 595
// module chunks = 70